import React from 'react'
import clsx from 'clsx'

import style from './banner-without-video.module.scss'

const BannerWithoutVideo = ({ wrapMod }: { wrapMod?: string }) => {
  return <div className={clsx(style.wrapper, wrapMod)}>Данный вебинар был без записи 😔</div>
}

export default BannerWithoutVideo
